import Tabs from '~/components/RedesignedTabs';
import * as client from '~/lib/client';
import history from '~/lib/history';

export default class AppBar extends React.Component {
  clone = () => {
    client.cloneForm(this.props.form.id).then(() => {
      history.push('/forms');
    });
  };

  pathValue = () => {
    const {
      form: { id },
    } = this.props;
    return window.location.pathname === '/forms'
      ? `/forms/${id}`
      : window.location.pathname;
  };

  render() {
    const { form, action } = this.props;

    return (
      <Tabs value={action || 'build'}>
        <Tabs.Tab
          to={`/forms/${form?.id}`}
          label="Build"
          value={'build'}
          disabled={!form}
        />
        <Tabs.Tab
          to={`/forms/${form?.id}/connectors`}
          label="Connectors"
          value="connectors"
          disabled={!form}
        />
        <Tabs.Tab
          to={`/forms/${form?.id}/responses`}
          label="Responses"
          value="responses"
          disabled={!form}
        />
      </Tabs>
    );
  }
}

AppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
